import useGetCustomerProfiles from './useGetCustomerProfiles'

export default useGetCustomerProfiles
